// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

export class MceIdlBuildResponse implements flatbuffers.IUnpackableObject<MceIdlBuildResponseT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): MceIdlBuildResponse {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsMceIdlBuildResponse(
    bb: flatbuffers.ByteBuffer,
    obj?: MceIdlBuildResponse,
  ): MceIdlBuildResponse {
    return (obj || new MceIdlBuildResponse()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsMceIdlBuildResponse(
    bb: flatbuffers.ByteBuffer,
    obj?: MceIdlBuildResponse,
  ): MceIdlBuildResponse {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new MceIdlBuildResponse()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  message(index: number): number | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint8(this.bb!.__vector(this.bb_pos + offset) + index) : 0;
  }

  messageLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  messageArray(): Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return new Uint8Array(
      this.bb!.bytes().buffer,
      this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset),
      this.bb!.__vector_len(this.bb_pos + offset),
    );
  }

  static startMceIdlBuildResponse(builder: flatbuffers.Builder) {
    builder.startObject(1);
  }

  static addMessage(builder: flatbuffers.Builder, messageOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, messageOffset, 0);
  }

  static createMessageVector(
    builder: flatbuffers.Builder,
    data: number[] | Uint8Array,
  ): flatbuffers.Offset {
    builder.startVector(1, data.length, 1);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addInt8(data[i]!);
    }
    return builder.endVector();
  }

  static startMessageVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(1, numElems, 1);
  }

  static endMceIdlBuildResponse(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // message
    return offset;
  }

  static createMceIdlBuildResponse(
    builder: flatbuffers.Builder,
    messageOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    MceIdlBuildResponse.startMceIdlBuildResponse(builder);
    MceIdlBuildResponse.addMessage(builder, messageOffset);
    return MceIdlBuildResponse.endMceIdlBuildResponse(builder);
  }

  unpack(): MceIdlBuildResponseT {
    return new MceIdlBuildResponseT(
      this.bb!.createScalarList<number>(this.message.bind(this), this.messageLength()),
    );
  }

  unpackTo(_o: MceIdlBuildResponseT): void {
    _o.message = this.bb!.createScalarList<number>(this.message.bind(this), this.messageLength());
  }

  unpackFields(...fields: string[]): MceIdlBuildResponseT {
    const t = new MceIdlBuildResponseT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("message")) {
      t.message = this.bb!.createScalarList<number>(this.message.bind(this), this.messageLength());
    }
    return t;
  }
}

export class MceIdlBuildResponseT implements flatbuffers.IGeneratedObject {
  constructor(public message: number[] = []) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.message === null || this.message === undefined) {
      throw new Error('Required field "message" is not set');
    }
    const message = MceIdlBuildResponse.createMessageVector(builder, this.message);

    return MceIdlBuildResponse.createMceIdlBuildResponse(builder, message);
  }

  clone(): MceIdlBuildResponseT {
    const obj = new MceIdlBuildResponseT();
    obj.message = [...this.message];
    return obj;
  }

  equals(other: MceIdlBuildResponseT): boolean {
    if (this.message.length !== other.message.length) return false;
    for (let i = 0; i < this.message.length; i++) {
      if (this.message[i] !== other.message[i]) return false;
    }
    return true;
  }
}

export function verifyMceIdlBuildResponse(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkVector(pos, 1);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "message");
  } finally {
    verifier.popDepth();
  }
}
